/**
 * Dependencies.
 */
import DeliverySurveyModel from '@/api/delivery-survey/delivery-survey.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class DeliverySurveyService extends BaseService<DeliverySurveyModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      DeliverySurveyModel,
      DeliverySurveyModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `deliverySurveyService`.
 */
export const deliverySurveyService = new DeliverySurveyService();
